import { createFileRoute } from "@tanstack/react-router";
import { TopPage } from "@/pages/TopPage";

// biome-ignore lint/nursery/useExplicitType: 型が長く書き出してもメリットが薄い
export const Route = createFileRoute("/")({
  component: TopPage,
});
